module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step3-c685b89c116043f766a081abae174d2b.jpg";